import { render, staticRenderFns } from "./mandatory-star.vue?vue&type=template&id=f1c5e7dc&"
import script from "./mandatory-star.vue?vue&type=script&lang=js&"
export * from "./mandatory-star.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1c5e7dc')) {
      api.createRecord('f1c5e7dc', component.options)
    } else {
      api.reload('f1c5e7dc', component.options)
    }
    module.hot.accept("./mandatory-star.vue?vue&type=template&id=f1c5e7dc&", function () {
      api.rerender('f1c5e7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/mandatory-star.vue"
export default component.exports